/**
 * Returns false while raw markdown is mid-token and sanitization may still change.
 */
export function isSpeechSanitizeStable(raw: string): boolean {
  const trimmed = raw.trimEnd();
  if (/\[[^\]]*$/.test(trimmed)) return false;
  if (/!\[[^\]]*$/.test(trimmed)) return false;

  let s = trimmed.replace(/`[^`]+`/g, '');
  if (s.includes('`')) return false;

  s = s.replace(/\*\*[^*]+\*\*/g, '');
  if (s.includes('**')) return false;

  s = s.replace(/~~[^~]+~~/g, '');
  if (s.includes('~~')) return false;

  s = s.replace(/__[^_\n]+__/g, '');
  s = s.replace(/(?<![_\w])_([^_\n]+)_(?![_\w])/g, '');
  if (/__/.test(s)) return false;
  if (/(?<![_\w])_[^_\n]*$/.test(s)) return false;

  s = s.replace(/(?<!\*)\*[^*\n]+\*(?!\*)/g, '');
  if (/(?<!\*)\*(?!\*)[^*\n]*$/.test(s)) return false;

  return true;
}
